import { memo } from 'react';
import DiscordWidget from 'root/src/client/web/base/DiscordWidget';
import ChatWidget from 'root/src/client/web/base/ChatWidget';
import { WIDGET_Z_INDEX } from 'root/src/client/v2/layout/fixtures/layout.fixtures';
export const WidgetsLayout = memo((props) => {
    const { children } = props;
    return (<>
			{children}
			<div style={{
            zIndex: WIDGET_Z_INDEX,
        }} className="flex flex-col fixed w-full">
				{/* @ts-ignore */}
				<DiscordWidget />
				<ChatWidget />
			</div>
		</>);
});
